var L=Object.defineProperty;var g=(e,o)=>L(e,"name",{value:o,configurable:!0});import*as m from"react";import{Global as x}from"@emotion/react";var T=Object.defineProperty,p=g((e,o)=>T(e,"name",{value:o,configurable:!0}),"l");function j(e={}){const{useRootStyles:o,useBodyStyles:t}=e,r="useRootStyles"in e&&o!=null;return{scope:r?"html":"body",rootStyles:r?o:t}}g(j,"__internalGetUseRootStyles"),p(j,"__internalGetUseRootStyles");const y="__default",B=p(e=>typeof e=="object"&&e!==null&&y in e,"hasDefault");function c(e,o,t,r,n){const a=o&&typeof o=="string"?o.split("."):[o];for(r=0;r<a.length;r++)e=e?e[a[r]]:n;return e===n?t:B(e)?e[y]:e}g(c,"get"),p(c,"get");const E=p((e,o)=>{if(e&&e.variant){let t={};for(const r in e){const n=e[r];if(r==="variant"){const a=typeof n=="function"?n(o):n,s=E(c(o,a),o);t={...t,...s}}else t[r]=n}return t}return e},"getObjectWithVariants"),H=[40,52,64].map(e=>e+"em"),P={space:[0,4,8,16,32,64,128,256,512],fontSizes:[12,14,16,20,24,32,48,64,72]},z={bg:"backgroundColor",m:"margin",mt:"marginTop",mr:"marginRight",mb:"marginBottom",ml:"marginLeft",mx:"marginX",my:"marginY",p:"padding",pt:"paddingTop",pr:"paddingRight",pb:"paddingBottom",pl:"paddingLeft",px:"paddingX",py:"paddingY"},C={marginX:["marginLeft","marginRight"],marginY:["marginTop","marginBottom"],paddingX:["paddingLeft","paddingRight"],paddingY:["paddingTop","paddingBottom"],scrollPaddingX:["scrollPaddingLeft","scrollPaddingRight"],scrollPaddingY:["scrollPaddingTop","scrollPaddingBottom"],size:["width","height"]},v={color:"colors",backgroundColor:"colors",borderColor:"colors",caretColor:"colors",columnRuleColor:"colors",opacity:"opacities",transition:"transitions",margin:"space",marginTop:"space",marginRight:"space",marginBottom:"space",marginLeft:"space",marginX:"space",marginY:"space",marginBlock:"space",marginBlockEnd:"space",marginBlockStart:"space",marginInline:"space",marginInlineEnd:"space",marginInlineStart:"space",padding:"space",paddingTop:"space",paddingRight:"space",paddingBottom:"space",paddingLeft:"space",paddingX:"space",paddingY:"space",paddingBlock:"space",paddingBlockEnd:"space",paddingBlockStart:"space",paddingInline:"space",paddingInlineEnd:"space",paddingInlineStart:"space",scrollPadding:"space",scrollPaddingTop:"space",scrollPaddingRight:"space",scrollPaddingBottom:"space",scrollPaddingLeft:"space",scrollPaddingX:"space",scrollPaddingY:"space",inset:"space",insetBlock:"space",insetBlockEnd:"space",insetBlockStart:"space",insetInline:"space",insetInlineEnd:"space",insetInlineStart:"space",top:"space",right:"space",bottom:"space",left:"space",gridGap:"space",gridColumnGap:"space",gridRowGap:"space",gap:"space",columnGap:"space",rowGap:"space",fontFamily:"fonts",fontSize:"fontSizes",fontWeight:"fontWeights",lineHeight:"lineHeights",letterSpacing:"letterSpacings",border:"borders",borderTop:"borders",borderRight:"borders",borderBottom:"borders",borderLeft:"borders",borderWidth:"borderWidths",borderStyle:"borderStyles",borderRadius:"radii",borderTopRightRadius:"radii",borderTopLeftRadius:"radii",borderBottomRightRadius:"radii",borderBottomLeftRadius:"radii",borderTopWidth:"borderWidths",borderTopColor:"colors",borderTopStyle:"borderStyles",borderBottomWidth:"borderWidths",borderBottomColor:"colors",borderBottomStyle:"borderStyles",borderLeftWidth:"borderWidths",borderLeftColor:"colors",borderLeftStyle:"borderStyles",borderRightWidth:"borderWidths",borderRightColor:"colors",borderRightStyle:"borderStyles",borderBlock:"borders",borderBlockEnd:"borders",borderBlockEndStyle:"borderStyles",borderBlockEndWidth:"borderWidths",borderBlockStart:"borders",borderBlockStartStyle:"borderStyles",borderBlockStartWidth:"borderWidths",borderBlockStyle:"borderStyles",borderBlockWidth:"borderWidths",borderEndEndRadius:"radii",borderEndStartRadius:"radii",borderInline:"borders",borderInlineEnd:"borders",borderInlineEndStyle:"borderStyles",borderInlineEndWidth:"borderWidths",borderInlineStart:"borders",borderInlineStartStyle:"borderStyles",borderInlineStartWidth:"borderWidths",borderInlineStyle:"borderStyles",borderInlineWidth:"borderWidths",borderStartEndRadius:"radii",borderStartStartRadius:"radii",outlineColor:"colors",boxShadow:"shadows",textShadow:"shadows",zIndex:"zIndices",width:"sizes",minWidth:"sizes",maxWidth:"sizes",height:"sizes",minHeight:"sizes",maxHeight:"sizes",flexBasis:"sizes",size:"sizes",blockSize:"sizes",inlineSize:"sizes",maxBlockSize:"sizes",maxInlineSize:"sizes",minBlockSize:"sizes",minInlineSize:"sizes",fill:"colors",stroke:"colors"},Y=p((e,o)=>{if(typeof o!="number"||o>=0){if(typeof o=="string"&&o.startsWith("-")){const n=o.substring(1);return`-${c(e,n,n)}`}return c(e,o,o)}const t=Math.abs(o),r=c(e,t,t);return typeof r=="string"?"-"+r:Number(r)*-1},"positiveOrNegative"),M=["margin","marginTop","marginRight","marginBottom","marginLeft","marginX","marginY","marginBlock","marginBlockEnd","marginBlockStart","marginInline","marginInlineEnd","marginInlineStart","top","bottom","left","right"].reduce((e,o)=>({...e,[o]:Y}),{}),X=p(e=>o=>{const t={},r=o&&o.breakpoints||H,n=[null,...r.map(a=>`@media screen and (min-width: ${a})`)];for(const a in e){const s=a;let i=e[s];if(typeof i=="function"&&(i=i(o||{})),!(i===!1||i==null)){if(!Array.isArray(i)){t[s]=i;continue}for(let l=0;l<i.slice(0,n.length).length;l++){const d=n[l];if(!d){t[s]=i[l];continue}t[d]=t[d]||{},i[l]!=null&&(t[d][s]=i[l])}}}return t},"responsive"),W=p((e={})=>(o={})=>{const t={...P,..."theme"in o?o.theme:o},r=E(typeof e=="function"?e(t):e,t),n=X(r)(t);let a={};for(const s in n){const i=n[s],l=typeof i=="function"?i(t):i;if(l&&typeof l=="object"){if(B(l)){a[s]=l[y];continue}const h=W(l)(t);a[s]=h;continue}const d=s in z?z[s]:s,k=d in v?v[d]:void 0,I=k?t?.[k]:c(t,d,{}),w=c(M,d,c)(I,l,l);if(d in C){const h=C[d];for(let u=0;u<h.length;u++)a[h[u]]=w}else a[d]=w}return a},"css");var _=Object.defineProperty,G=g((e,o)=>_(e,"name",{value:o,configurable:!0}),"e$1");const O=G(()=>m.createElement(x,{styles:`
      html {
        line-height: 1.5;
        -webkit-text-size-adjust: 100%;
        font-family: system-ui, sans-serif;
        -webkit-font-smoothing: antialiased;
        text-rendering: optimizeLegibility;      
        -moz-osx-font-smoothing: grayscale; 
        touch-action: manipulation;
      }
      body {
        position: relative;
        min-height: 100%;
        font-feature-settings: 'kern';
      }
      *,
      *::before,
      *::after {
        border-width: 0;
        border-style: solid;
        box-sizing: border-box;
      }
      main {
        display: block;
      }
      hr {
        border-top-width: 1px;
        box-sizing: content-box;
        height: 0;
        overflow: visible;
      }
      pre,
      code,
      kbd,
      samp {
        font-family: SFMono-Regular,  Menlo, Monaco, Consolas, monospace;
        font-size: 1em;
      }
      a {
        background-color: rgba(255, 255, 255, 0); /* transparent */
        color: inherit;
        text-decoration: inherit;
      }
      abbr[title] {
        border-bottom: none;
        text-decoration: underline;
        -webkit-text-decoration: underline dotted;
        text-decoration: underline dotted;
      }
      b,
      strong {
        font-weight: bold;
      }
      small {
        font-size: 80%;
      }
      sub,
      sup {
        font-size: 75%;
        line-height: 0;
        position: relative;
        vertical-align: baseline;
      }
      sub {
        bottom: -0.25em;
      }
      sup {
        top: -0.5em;
      }
      img {
        border-style: none;
      }
      button,
      input,
      optgroup,
      select,
      textarea {
        font-family: inherit;
        font-size: 100%;
        line-height: 1.15;
        margin: 0;
      }
      button,
      input {
        overflow: visible;
      }
      button,
      select {
        text-transform: none;
      }
      button::-moz-focus-inner,
      [type="button"]::-moz-focus-inner,
      [type="reset"]::-moz-focus-inner,
      [type="submit"]::-moz-focus-inner {
        border-style: none;
        padding: 0;
      }
      fieldset {
        padding: 0.35em 0.75em 0.625em;
      }
      legend {
        box-sizing: border-box;
        color: inherit;
        display: table;
        max-width: 100%;
        padding: 0;
        white-space: normal;
      }
      progress {
        vertical-align: baseline;
      }
      textarea {
        overflow: auto;
      }
      [type="checkbox"],
      [type="radio"] {
        box-sizing: border-box;
        padding: 0;
      }
      [type="number"]::-webkit-inner-spin-button,
      [type="number"]::-webkit-outer-spin-button {
        -webkit-appearance: none !important;
      }
      input[type="number"] {
        -moz-appearance: textfield;
      }
      [type="search"] {
        -webkit-appearance: textfield;
        outline-offset: -2px;
      }
      [type="search"]::-webkit-search-decoration {
        -webkit-appearance: none !important;
      }
      ::-webkit-file-upload-button {
        -webkit-appearance: button;
        font: inherit;
      }
      details {
        display: block;
      }
      summary {
        display: list-item;
      }
      template {
        display: none;
      }
      [hidden] {
        display: none !important;
      }
      body,
      blockquote,
      dl,
      dd,
      h1,
      h2,
      h3,
      h4,
      h5,
      h6,
      hr,
      figure,
      p,
      pre {
        margin: 0;
      }
      button {
        background: rgba(255, 255, 255, 0); /* transparent */
        padding: 0;
      }
      fieldset {
        margin: 0;
        padding: 0;
      }
      ol,
      ul {
        margin: 0;
        padding: 0;
      }
      textarea {
        resize: vertical;
      }
      button,
      [role="button"] {
        cursor: pointer;
      }
      button::-moz-focus-inner {
        border: 0 !important;
      }
      table {
        border-collapse: collapse;
      }
      h1,
      h2,
      h3,
      h4,
      h5,
      h6 {
        font-size: inherit;
        font-weight: inherit;
      }
      button,
      input,
      optgroup,
      select,
      textarea {
        padding: 0;
        line-height: inherit;
        color: inherit;
      }
      img,
      video,
      canvas,
      audio,
      iframe,
      embed,
      object {
        display: block;
        vertical-align: middle;
      }
      img,
      video {
        max-width: 100%;
        height: auto;
      }
      svg {
        vertical-align: middle;
        display: inline-block;
      }
      [data-js-focus-visible] :focus:not([data-focus-visible-added]) {
        outline: none;
        box-shadow: none;
      }
      select::-ms-expand {
        display: none;
      }
      :focus {
        outline: none;
      }
    `}),"CSSReset");let $=["640px","768px","1024px","1280px"];const N={xs:"0.75rem",sm:"0.875rem",base:"1rem",lg:"1.125rem",xl:"1.25rem","2xl":"1.5rem","3xl":"1.875rem","4xl":"2.25rem","5xl":"3rem","6xl":"3.75rem","7xl":"4.5rem","8xl":"6rem","9xl":"8rem"},F={normal:400,bold:600},U={...F,body:F.normal,heading:F.bold},S={body:"'Benton Sans', 'Helvetica Neue', 'Arial', sans-serif",mono:"'Menlo', 'Monaco', 'Consolas', 'Liberation Mono', 'Courier New', 'monospace'"},V={...S,body:S.body,heading:"inherit",monospace:S.mono},q={tighter:"-0.05em",tight:"-0.025em",normal:"0",wide:"0.025em",wider:"0.05em",widest:"0.1em"},K={none:"1",shorter:"1.25",short:"1.375",normal:"1.5",base:"1.5",tall:"1.625",taller:"2",body:"1.5",heading:"1.25"},J={"4xl":{fontSize:["3xl","4xl"],lineHeight:["normal","short"]},"3xl":{fontSize:["2xl","3xl"],lineHeight:["normal","normal"]},"2xl":{fontSize:["xl","2xl"],lineHeight:["normal","normal"]},xl:{fontSize:["lg","xl"],lineHeight:["normal","normal"]},lg:{fontSize:["lg","lg"],lineHeight:["normal","normal"]},base:{fontSize:["base","base"],lineHeight:["tall","tall"]},sm:{fontSize:["sm","sm"],lineHeight:["tall","tall"]},xs:{fontSize:["xs","xs"],lineHeight:["tall","tall"]}},Q={none:"0",sm:"0.125rem",base:"0.25rem",md:"0.375rem",lg:"0.5rem",xl:"0.75rem","2xl":"1rem","3xl":"1.5rem",full:"9999px"},D={px:"1px",0:"0",.5:"0.125rem",1:"0.25rem",1.5:"0.375rem",2:"0.5rem",2.5:"0.625rem",3:"0.75rem",3.5:"0.875rem",4:"1rem",5:"1.25rem",6:"1.5rem",7:"1.75rem",8:"2rem",9:"2.25rem",10:"2.5rem",12:"3rem",14:"3.5rem",16:"4rem",20:"5rem",24:"6rem",28:"7rem",32:"8rem",36:"9rem",40:"10rem",44:"11rem",48:"12rem",52:"13rem",56:"14rem",60:"15rem",64:"16rem",72:"18rem",80:"20rem",96:"24rem"},Z={"1/2":"50%","1/3":"33.333333%","2/3":"66.666667%","1/4":"25%","2/4":"50%","3/4":"75%","1/5":"20%","2/5":"40%","3/5":"60%","4/5":"80%","1/6":"16.666667%","2/6":"33.333333%","3/6":"50%","4/6":"66.666667%","5/6":"83.333333%","1/12":"8.333333%","2/12":"16.666667%","3/12":"25%","4/12":"33.333333%","5/12":"41.666667%","6/12":"50%","7/12":"58.333333%","8/12":"66.666667%","9/12":"75%","10/12":"83.333333%","11/12":"91.666667%"},ee={...D,full:"100%",screenHeight:"100vh",screenWidth:"100vw","3xs":"14rem","2xs":"16rem",xs:"20rem",sm:"24rem",md:"28rem",lg:"32rem",xl:"36rem","2xl":"42rem","3xl":"48rem","4xl":"56rem","5xl":"64rem","6xl":"72rem","7xl":"80rem",...Z},oe={xs:"0 0 0 1px rgba(0, 0, 0, 0.05)",sm:"0 1px 2px 0 rgba(0, 0, 0, 0.05)",default:"0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06)",md:"0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)",lg:"0 10px 15px -3px rgba(0, 0, 0, 0.15), 0 4px 6px -2px rgba(0, 0, 0, 0.05)",xl:"0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)","2xl":"0 25px 50px -12px rgba(0, 0, 0, 0.25)",inner:"inset 0 2px 4px 0 rgba(0, 0, 0, 0.06)",outline:"0 0 0 3px rgba(66, 153, 225, 0.5)",none:"none"},te={hide:-1,auto:"auto",base:0,docked:10,dropdown:1e3,sticky:1100,banner:1200,overlay:1300,modal:1400,popover:1500,skipLink:1600,toast:1700,tooltip:1800},f={fontFamily:"heading",fontWeight:"heading",lineHeight:"heading",m:0,mb:1},re={root:{fontFamily:"body",lineHeight:"body",fontWeight:"body",backgroundColor:"background",color:"gray.700"},html:{variant:"styles.root"},a:{textDecoration:"underline",fontWeight:"bold",cursor:"pointer",color:"gray.900"},h1:{...f,variant:"text.4xl",mt:2},h2:{...f,variant:"text.3xl",mt:2},h3:{...f,variant:"text.2xl",mt:3},h4:{...f,variant:"text.xl"},h5:{...f,variant:"text.lg"},h6:{...f,variant:"text.sm",mb:2},code:{},pre:{},hr:{backgroundColor:"gray.200",border:0,height:"1px",mt:3,mb:3}},ne={property:{none:"none",all:"all",default:"background-color, border-color, color, fill, stroke, opacity, box-shadow, transform",colors:"background-color, border-color, color, fill, stroke",opacity:"opacity",shadow:"box-shadow",transform:"transform"},timingFunction:{linear:"linear",in:"cubic-bezier(0.4, 0, 1, 1)",out:"cubic-bezier(0, 0, 0.2, 1)","in-out":"cubic-bezier(0.4, 0, 0.2, 1)"},duration:{75:"75ms",100:"100ms",150:"150ms",200:"200ms",300:"300ms",500:"500ms",700:"700ms",1e3:"1000ms"}},ie={px:"1px",0:"0",1:"1px",2:"2px",4:"4px",8:"8px"},b={transparent:"rgba(255, 255, 255, 0)",black:"#000",white:"#fff",gray:{50:"#FAFAFB",100:"#FAFAFB",200:"#ECEDEE",300:"#D8D9DB",400:"#7D8088",500:"#6A6D77",600:"#373A44",700:"#292C33",800:"#1C1D22",900:"#0E0F11"},red:{100:"#FAEAEB",200:"#F5D4D7",300:"#EBA9AF",400:"#E07F86",500:"#D6545E",600:"#CC2936",700:"#A3212B",800:"#7A1920",900:"#521016"},orange:{100:"#FFF3E7",200:"#FFE7CF",300:"#FFCFA0",400:"#FFB870",500:"#FFA041",600:"#FF8811",700:"#CC6D0E",800:"#99520A",900:"#663607"},yellow:{100:"#FFFAED",200:"#FFF6DA",300:"#FFECB5",400:"#FFE390",500:"#FFD96B",600:"#FFD046",700:"#CCA638",800:"#997D2A",900:"#66531C"},green:{100:"#EFFAE1",200:"#E3F5D2",300:"#CBEEB8",400:"#A1E594",500:"#6CDA72",600:"#3ECF65",700:"#19C164",800:"#18703B",900:"#049C67",950:"#052E16"},teal:{100:"#E6F8F9",200:"#CDF2F3",300:"#9BE4E6",400:"#6AD7DA",500:"#38C9CD",600:"#06BCC1",700:"#048487",800:"#035E61",900:"#02383A"},blue:{100:"#E6F2FF",200:"#CCE5FF",300:"#99CCFF",400:"#66B2FF",500:"#3399FF",600:"#007FFF",700:"#0066CC",800:"#004C99",900:"#003366"},indigo:{100:"#ebf4ff",200:"#c3dafe",300:"#a3bffa",400:"#7f9cf5",500:"#667eea",600:"#5a67d8",700:"#4c51bf",800:"#434190",900:"#3c366b"},purple:{100:"#EDEBF5",200:"#DCD7EB",300:"#B9AED7",400:"#9586C3",500:"#725DAF",600:"#4F359B",700:"#3F2A7C",800:"#2F205D",900:"#20153E"},pink:{100:"#FAEBF9",200:"#F6D7F2",300:"#EDAFE5",400:"#E388D9",500:"#DA60CC",600:"#D138BF",700:"#A72D99",800:"#7D2273",900:"#54164C"}},ae={...b,background:b.white,current:"currentColor",text:"gray.700",awning:{primary:b.green[600],success:b.green[700],baseText:b.gray[700],critical:b.red[600],warning:b.orange[600]}},A={colors:ae,borderWidths:ie,breakpoints:$,fonts:V,fontSizes:N,fontWeights:U,letterSpacings:q,lineHeights:K,sizes:ee,shadows:oe,space:D,radii:Q,zIndices:te,styles:re,transitions:ne,text:J};var le=Object.defineProperty,R=g((e,o)=>le(e,"name",{value:o,configurable:!0}),"t");const se=R(({children:e})=>{const o=W(A.styles)(A);return m.createElement(m.Fragment,null,m.createElement(O,null),m.createElement(de,null),m.createElement(x,{styles:o}),e)},"BaseStyles"),de=R(()=>m.createElement(x,{styles:`
              @font-face {
                /* Medium */
                font-family: 'Benton Sans';
                font-display: swap;
                font-weight: 600;
                font-weight: bold;
                font-style: normal;
              
                src: url("//cloud.typenetwork.com/projectLicenseWeb/18616/fontfile/eot/?c796544939a67974ecc99fa2e82af00fe5827c2d");
                src: url("//cloud.typenetwork.com/projectLicenseWeb/18616/fontfile/eot/?c796544939a67974ecc99fa2e82af00fe5827c2d#iefix") format("embedded-opentype"),
                     url("//cloud.typenetwork.com/projectLicenseWeb/18616/fontfile/woff2/?c796544939a67974ecc99fa2e82af00fe5827c2d") format("woff2"),
                     url("//cloud.typenetwork.com/projectLicenseWeb/18616/fontfile/woff/?c796544939a67974ecc99fa2e82af00fe5827c2d") format("woff");
              }
              
              @font-face {
                font-family: 'Benton Sans';
                font-display: swap;
                font-weight: normal;
                font-style: normal;
              
                src: url("//cloud.typenetwork.com/projectLicenseWeb/18615/fontfile/eot/?c796544939a67974ecc99fa2e82af00fe5827c2d");
                src: url("//cloud.typenetwork.com/projectLicenseWeb/18615/fontfile/eot/?c796544939a67974ecc99fa2e82af00fe5827c2d#iefix") format("embedded-opentype"),
                     url("//cloud.typenetwork.com/projectLicenseWeb/18615/fontfile/woff2/?c796544939a67974ecc99fa2e82af00fe5827c2d") format("woff2"),
                     url("//cloud.typenetwork.com/projectLicenseWeb/18615/fontfile/woff/?c796544939a67974ecc99fa2e82af00fe5827c2d") format("woff");        
              }
              
              html {
                font-size: 16px;
                scroll-behavior: smooth;
                letter-spacing: 0.005em;
              }
              
              html,
              body {
                height: 100%;
                width: 100%;
              }
              
              *,
              *:after,
              *:before {
                box-sizing: border-box;
              }
              
              body {
                margin: 0;
              }
              
        `}),"FontAndStuff");export{se as BaseStyles};
//# sourceMappingURL=index.mjs.map
